export enum AuthorityManufacter {
  REGISTER_MANUFACTER_VIEW = '1.5.1',
  REGISTER_MANUFACTER_ACTIVE_INACTIVE = '1.5.4',
  REGISTER_MANUFACTER_REPORTS = '1.5.5',
}
